import React, { useEffect, useState } from 'react';
import { Nav } from '@alifd/next';
import { asideMenuConfig } from '../../menuConfig';
import { appHistory } from '@ice/stark-app';

const categoryList = asideMenuConfig.map((menuConfig) => menuConfig.category);

const { SubNav } = Nav;
const NavItem = Nav.Item;

const AUTH_CONFIG = {
  admin: true,
  guest: false,
};

export interface IMenuItem {
  name: string;
  path: string;
  icon?: string;
  children?: IMenuItem[];
}

function getNavMenuItems(menusData: any[], initIndex?: number | string, auth?: any) {
  if (!menusData) {
    return [];
  }

  return menusData
    .filter((item) => {
      let roleAuth = true;
      // if item.roles is [] or undefined, roleAuth is true
      if (auth && item.auth && item.auth instanceof Array) {
        if (item.auth.length) {
          roleAuth = item.auth.some((key) => auth[key]);
        }
      }
      return item.name && !item.hideInMenu && roleAuth;
    })
    .map((item, index) => {
      return getSubMenuOrItem(item, `${initIndex}-${index}`, auth);
    });
}

function getSubMenuOrItem(item: IMenuItem, index?: number | string, auth?: any) {
  if (item.children && item.children.some((child) => child.name)) {
    const childrenItems = getNavMenuItems(item.children, index, auth);
    if (childrenItems && childrenItems.length > 0) {
      const subNav = (
        <SubNav key={item.name} icon={item.icon?.includes('icon-') ? <i className={`iconfont lz-cjyx-icon lz-cjyx-medium lz-cjyx-nav-icon ${item.icon}`} /> : item.icon} label={item.name}>
          {childrenItems}
        </SubNav>
      );

      return subNav;
    }
    return null;
  }
  const navItem = (
    <NavItem
      key={item.path}
      icon={item.icon}
      onClick={() => {
        appHistory.push(item.path);
      }}
    >
      {item.name}
    </NavItem>
  );

  return navItem;
}

const PageNav = ({ pathname }) => {
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [menus, setMenus] = useState<any[]>([]);
  const category = pathname.split('/')[2];
  useEffect(() => {
    if (!categoryList.includes(category)) {
      return;
    }
    const menus = asideMenuConfig.filter((menuConfig) => menuConfig.category === category)[0].children;
    setMenus(menus);
    const curSubNav = menus.find((menuConfig) => {
      return menuConfig.children && checkChildPathExists(menuConfig);
    });
    function checkChildPathExists(menuConfig) {
      return menuConfig.children.some((child) => {
        return child.children ? checkChildPathExists(child) : child.path === pathname;
      });
    }

    if (curSubNav && !openKeys.includes(curSubNav.name)) {
      setOpenKeys([...openKeys, curSubNav.name]);
    }
  }, [pathname]);

  return (
    <Nav
      type="primary"
      openKeys={openKeys}
      selectedKeys={[pathname]}
      defaultSelectedKeys={[pathname]}
      defaultOpenAll
      embeddable
      hasArrow={false}
      onOpen={(keys) => {
        // @ts-ignore
        setOpenKeys(keys);
      }}
    >
      {getNavMenuItems(menus, 0, AUTH_CONFIG)}
    </Nav>
  );
};


export default PageNav;
